// Constantes

/**
 * API base URL
 */
export const BASE_URL = process.env.REACT_APP_API_URL;
//export const BASE_URL = "http://localhost:8002/api/v1/";

// export const WS_URL = process.env.REACT_APP_WS_URL;

/**
 * Genders list for dropdowns
 */
export const GENDERS = [
  { label: "Masculino", value: "M" },
  { label: "Femenino", value: "F" },
];

export const CONDITIONS = [
  { label: "Activo", value: "A" },
  { label: "Jubilado", value: "J" },
  { label: "Sobreviviente", value: "S" },
];
/**
 * Phone codes for dropdowns
 */
export const PHONE_CODES = [
  { label: "0412", value: "58412" },
  { label: "0414", value: "58414" },
  { label: "0416", value: "58416" },
  { label: "0424", value: "58424" },
  { label: "0426", value: "58426" },
  { label: "0422", value: "58422" },
];

/**
 * Months list for dropdowns
 */
export const MONTHS = [
  { label: "Enero", value: 1 },
  { label: "Febrero", value: 2 },
  { label: "Marzo", value: 3 },
  { label: "Abril", value: 4 },
  { label: "Mayo", value: 5 },
  { label: "Junio", value: 6 },
  { label: "Julio", value: 7 },
  { label: "Agosto", value: 8 },
  { label: "Septiembre", value: 9 },
  { label: "Octubre", value: 10 },
  { label: "Noviembre", value: 11 },
  { label: "Diciembre", value: 12 },
];

/**
 * List of user roles for dropdowns
 */
export const USER_ROLES_DROPDOWN = [
  { label: "Conciliador", value: "conciliator" },
  { label: "Auditor", value: "auditor" },
  { label: "Gerente general", value: "manager" },
  { label: "Analista regional", value: "analyst" },
  { label: "Proveedor", value: "medicalCenter" },
];

/**
 * List of day numbers with labels
 */
export const DAYS = [
  { id: 1, shortLabel: "Lun.", fullLabel: "Lunes", apiLabel: "lunes" },
  { id: 2, shortLabel: "Mar.", fullLabel: "Martes", apiLabel: "martes" },
  { id: 3, shortLabel: "Mie.", fullLabel: "Miércoles", apiLabel: "miércoles" },
  { id: 4, shortLabel: "Jue.", fullLabel: "Jueves", apiLabel: "jueves" },
  { id: 5, shortLabel: "Vie.", fullLabel: "Viernes", apiLabel: "viernes" },
  { id: 6, shortLabel: "Sab.", fullLabel: "Sábado", apiLabel: "sábado" },
  { id: 7, shortLabel: "Dom.", fullLabel: "Domingo", apiLabel: "domingo" },
];

/**
 * List of possible medical case file types
 */
export const MEDICAL_FILE_TYPES = [
  { label: "Orden médica", value: "orden_medica" },
  { label: "Examen médico", value: "examen_medico" },
  { label: "Resultado de examen", value: "resultado_examen" },
  { label: "Receta médica", value: "receta_medica" },
  { label: "Estudio médico", value: "estudio_medico" },
  { label: "Cédula", value: "cedula" },
  { label: "Ficha del titular", value: "ficha_titular" },
  { label: "Informe médico", value: "informe_medico" },
  { label: "Imagenología", value: "imagenologia" },
  { label: "Otro", value: "otro" },
];

/**
 * List of possible status of the medical staff of a medical center
 */
export class MedicalStaffStatus {
  static TOTAL = "total";
  static ASIGNADOS = "assigned";
  static SIN_ASIGNAR = "not_assigned";

  static colors = {
    [MedicalStaffStatus.TOTAL]: "#a1a1a1",
    [MedicalStaffStatus.ASIGNADOS]: "#84cc16",
    [MedicalStaffStatus.SIN_ASIGNAR]: "#f0b100",
  };

  static getColor(status) {
    return MedicalStaffStatus.colors[status] || "transparent";
  }

  static labels = {
    [MedicalStaffStatus.TOTAL]: "Total",
    [MedicalStaffStatus.ASIGNADOS]: "Asignado",
    [MedicalStaffStatus.SIN_ASIGNAR]: "Sin asignar",
  };
  static getLabel(status) {
    return MedicalStaffStatus.labels[status] || "Desconocido";
  }
}

/**
 * Class of available medical case status
 */
export class CaseStatus {
  static PENDIENTE = "pendiente";
  static RESCHEDULED = "agendado";
  static REMESADO = "remesado";
  static ATENDIDO = "atendido";
  static CONCILIADO = "conciliado";
  static AUDITADO = "auditado";
  static ANULADO = "anulado";
  static TO_REVIEW = "en_revision";
  static TO_SUBSCRIBE = "por_suscribir";
  static WITHOUT_FUNDS = "sin_fondo";
  static PRIORITIZED = "priorizado";
  static REASSIGNED = "reassigned";
  static REQUESTED = "solicitado";

  static colors = {
    [CaseStatus.TO_REVIEW]: "#a1a1a1",
    [CaseStatus.TO_SUBSCRIBE]: "#f0b100",
    [CaseStatus.ATENDIDO]: "#84cc16",
    [CaseStatus.REMESADO]: "#0ea5e9",
    [CaseStatus.RESCHEDULED]: "#14b8a6",
    [CaseStatus.PENDIENTE]: "#f97316",
    [CaseStatus.CONCILIADO]: "#7e22ce",
    [CaseStatus.AUDITADO]: "#22c55e",
    [CaseStatus.ANULADO]: "#ef4444",
    [CaseStatus.WITHOUT_FUNDS]: "#ff6467",
    [CaseStatus.PRIORITIZED]: "#499fd8",
    [CaseStatus.REASSIGNED]: "#4d179a",
    [CaseStatus.REQUESTED]: "#a1a1a1",
  };

  static getColor(status) {
    return CaseStatus.colors[status] || "transparent";
  }

  static labels = {
    [CaseStatus.PRIORITIZED]: "Priorizado",
    [CaseStatus.PENDIENTE]: "Pendiente",
    [CaseStatus.RESCHEDULED]: "Agendado",
    [CaseStatus.REMESADO]: "Remesado",
    [CaseStatus.ATENDIDO]: "Atendido",
    [CaseStatus.ANULADO]: "Anulado",
    [CaseStatus.CONCILIADO]: "Conciliado",
    [CaseStatus.AUDITADO]: "Auditado",
    [CaseStatus.TO_REVIEW]: "Revisión",
    [CaseStatus.TO_SUBSCRIBE]: "Por Suscribir",
    [CaseStatus.WITHOUT_FUNDS]: "Sin Fondo",
    [CaseStatus.REASSIGNED]: "Reasignado",
    [CaseStatus.REQUESTED]: "Solicitado por Paciente",
  };
  static getLabel(status) {
    return CaseStatus.labels[status] || "Desconocido";
  }
}

/**
 * Class of available user roles
 */
export class UserRole {
  static MASTER = "master";
  static CONCILIATOR = "conciliator";
  static AUDITOR = "auditor";
  static MEDICAL_CENTER = "medical_center";
  static ANALYST = "analyst";
  static MANAGER = "manager";
  static ANALYST_SUPPLIER = "analyst_supplier";
  static ANALYST_COMPANY_CLIENT = "analyst_company_client";
  static CALL_CENTER = "call_center";
  static LABORATORY = "laboratory";
  static SUB_ADMINISTRATOR = "sub_administrator";
  static MEDICAL_CENTER_MASTER = "medical_center_master";

  static all() {
    return [
      UserRole.MASTER,
      UserRole.CONCILIATOR,
      UserRole.AUDITOR,
      UserRole.MEDICAL_CENTER,
      UserRole.ANALYST,
      UserRole.MANAGER,
      UserRole.ANALYST_SUPPLIER,
      UserRole.ANALYST_COMPANY_CLIENT,
      UserRole.CALL_CENTER,
      UserRole.LABORATORY,
      UserRole.SUB_ADMINISTRATOR,
    ];
  }
}

const ROLE_TO_ROUTE = {
  [UserRole.MASTER]: "/casos",
  [UserRole.CONCILIATOR]: "/casos",
  [UserRole.AUDITOR]: "/auditorias",
  [UserRole.MEDICAL_CENTER]: "/casos",
  [UserRole.ANALYST]: "/casos",
  [UserRole.MANAGER]: "/casos",
  [UserRole.ANALYST_SUPPLIER]: "/proveedores",
  [UserRole.ANALYST_COMPANY_CLIENT]: "/casos",
  [UserRole.CALL_CENTER]: "/casos",
  [UserRole.LABORATORY]: "/casos",
  [UserRole.SUB_ADMINISTRATOR]: "/casos",
};

/**
 * Class for fund types
 */
export class FundType {
  static PREPAY = "prepay";
  static POSTPAY = "postpay";

  static CHOICES = [
    { value: FundType.PREPAY, label: "Prepago" },
    { value: FundType.POSTPAY, label: "Postpago" },
  ];
}


export const getRouteForRole = (role) => {
  return ROLE_TO_ROUTE[role] || "/"; // Ruta por defecto si el rol no está definido
};

export const PAYMENTS_ROUTE = "/pagos/clientes";

/**
 * List of roles with allowed access per route
 */
export const ROUTE_ALLOWED_ROLES = {
  // Casos Médicos
  "/casos/nuevo": [
    UserRole.CONCILIATOR,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.CALL_CENTER,
    UserRole.LABORATORY,
    UserRole.MASTER,
  ],
  "/casos": [
    UserRole.CONCILIATOR,
    UserRole.MEDICAL_CENTER,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.CALL_CENTER,
    UserRole.ANALYST_SUPPLIER,
    UserRole.LABORATORY,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  "/casos/anulados": [
    UserRole.CONCILIATOR,
    UserRole.MEDICAL_CENTER,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.CALL_CENTER,
    UserRole.ANALYST_SUPPLIER,
    UserRole.LABORATORY,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  "/casos/por-suscribir": [
    UserRole.MANAGER,
    UserRole.CALL_CENTER,
    UserRole.MASTER,
  ],
  "/casos/carga-masiva": [
    UserRole.MASTER,
    UserRole.CALL_CENTER,
    UserRole.LABORATORY,
  ],
  "/casos/solicitudes-pendientes": [
    UserRole.MASTER,
    UserRole.CALL_CENTER,
    UserRole.LABORATORY,
  ],
  "/casos/:caseId/asignar-solicitud": [
    UserRole.MASTER,
    UserRole.CALL_CENTER,
    UserRole.LABORATORY,
  ],

  "/medicos": [UserRole.MEDICAL_CENTER],

  "/casos/por-suscribir/:caseId": [
    UserRole.MANAGER,
    UserRole.CALL_CENTER,
    UserRole.MASTER,
  ],
  "/casos/:caseId/reasignar": [UserRole.SUB_ADMINISTRATOR],
  "/casos/reasignados": [UserRole.SUB_ADMINISTRATOR],
  "/casos/reasignados/:caseId": [UserRole.SUB_ADMINISTRATOR],
  "/casos-pendientes": [UserRole.MEDICAL_CENTER, UserRole.SUB_ADMINISTRATOR],
  "/casos/:caseId": [
    UserRole.CONCILIATOR,
    UserRole.MEDICAL_CENTER,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.LABORATORY,
    UserRole.CALL_CENTER,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  "/casos/:caseId/editar": [
    UserRole.CONCILIATOR,
    UserRole.MEDICAL_CENTER,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.LABORATORY,
    UserRole.CALL_CENTER,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  "/requerimientos": [],

  // Anticipos
  "/anticipos/nuevo": [
    UserRole.CONCILIATOR,
    UserRole.AUDITOR,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  "/anticipos": [
    UserRole.CONCILIATOR,
    UserRole.AUDITOR,
    // UserRole.CALL_CENTER,
    // UserRole.MEDICAL_CENTER,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  "/anticipos/proveedores/:centerId": [
    // UserRole.MEDICAL_CENTER,
    UserRole.CONCILIATOR,
    UserRole.AUDITOR,
    // UserRole.CALL_CENTER,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],

  // Baremos
  "/baremos": [
    UserRole.MASTER,
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  "/baremos/:clientId": [
    UserRole.MASTER,
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  "/baremos/nuevo": [
    UserRole.CONCILIATOR,
    UserRole.MANAGER,
    UserRole.AUDITOR,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
  ],
  "/baremos/:baremoId": [
    UserRole.CONCILIATOR,
    UserRole.MANAGER,
    UserRole.AUDITOR,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
  ],

  // Saldo
  "/saldo": [
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  "/pagos/clientes": [
    UserRole.MEDICAL_CENTER_MASTER,
    // TODO: Eliminar medical_center
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  "/pagos/clientes/:clientId": [
    UserRole.MEDICAL_CENTER_MASTER,

    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  "/pagos/detalle/:billingID": [
    UserRole.MEDICAL_CENTER_MASTER,
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],

  // Proveedores
  "/proveedores": [
    // UserRole.CONCILIATOR,
    // UserRole.MEDICAL_CENTER,
    // UserRole.MANAGER,
    // UserRole.AUDITOR,
    // UserRole.ANALYST_SUPPLIER,
    // UserRole.MASTER
  ],
  "/proveedores/nuevo": [
    // UserRole.CONCILIATOR,
    // UserRole.MEDICAL_CENTER,
    // UserRole.MANAGER,
    // UserRole.AUDITOR,
    // UserRole.ANALYST_SUPPLIER,
    // UserRole.MASTER
  ],
  "/centro-medico/servicios": [
    UserRole.CONCILIATOR,
    // UserRole.MEDICAL_CENTER,
    UserRole.MANAGER,
    UserRole.AUDITOR,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
  ],
  "/proveedores/editar/:centerId": [
    // UserRole.CONCILIATOR,
    // UserRole.MEDICAL_CENTER,
    // UserRole.MANAGER,
    // UserRole.AUDITOR,
    // UserRole.ANALYST_SUPPLIER,
    // UserRole.MASTER
  ],

  // Facturas
  "/centro-medico/facturas": [],
  "/centro-medico/facturas/nueva": [],

  // Usuarios
  "/usuarios": [],
  "/usuarios/cliente": [],

  "/asegurados": [],
  "/rms": [],

  "/reportes/casos-medicos": [],

  "/chat": UserRole.all(),

  // Logout
  "/logout": UserRole.all(),

  // API Generar token
  "/api/generar-token": [UserRole.MEDICAL_CENTER, UserRole.LABORATORY],

  // Nuevas Rutas Agregadas
  "/fondo-incurrido/crear-pago": [],
  "/fondo-incurrido/abonos": [UserRole.MASTER, UserRole.MEDICAL_CENTER],
};

export const INITIAL_PATIENT_FORM = {
  ciType: "V",
  ci: "",
  name: "",
  sex: null,
  birthDate: "",
  phoneCode: "58412",
  phoneNumber: "",
  diagnosis: null,
  client: null,
  subsidiary: null,
  isHolder: true,
  shouldCreatePatient: false,
  minorId: "",
  isMinor: false,
};

export const INITIAL_HOLDER_FORM = {
  step: 1,
  ciType: "V",
  ci: "",
  name: "",
  sex: null,
  birthDate: "",
  birthDay: null,
  birthMonth: null,
  birthYear: null,
  phoneCode: "58412",
  phoneNumber: "",
  shouldCreateHolder: false,
  condition: "A",
  optionalPhoneCode: "58412",
  optionalPhoneNumber: "",
  patient: INITIAL_PATIENT_FORM,
  medicalOrder: null,
};
